import NotFound from '../views/not-found/NotFound.vue';

export default [
  {
    path: '/404',
    name: 'NotFound',
    component: NotFound,
    meta: {
      title: 'No encontrada',
      staticBreadCrumbs: [
        {
          text: 'Transporte Terrestre',
          link: 'https://www.transportes.gob.es/transporte_terrestre',
        },
        {
          text: 'Viajero de autobús y tren',
          link: 'https://www.transportes.gob.es/transporte_terrestre#Viajeros_de_autobus_y_tren',
        },
      ],
    },
  },
  {
    path: '/:pathMatch(.*)*', // will match everything and put it under `$route.params.pathMatch`
    name: 'PathMatch',
    redirect: (to) => ({
      name: 'NotFound',
      params: {}, // (!) https://github.com/vuejs/router/issues/1617
      query: {
        from: encodeURIComponent(to.path),
      },
    }),
  },
];


